import { createAction, props } from '@ngrx/store';
import { IError } from '../state/app.state';
import { IBulkAcceptanceData } from '@app/@shared/Models/bulk-acceptance.model';

export const BeginBulkAcceptance = createAction('[BULK ACTION] - BULK ACTION INIT', props<{ requestBody: any }>());
export const GetBulkAcceptanceSuccess = createAction('[BULK ACTION] - BULK ACTION ITEM SUCCESS', props<{ payload: IBulkAcceptanceData }>());
export const GetBulkAcceptanceError = createAction('[BULK ACTION] - BULK ACTION ITEM ERROR', props<{ payload: IError }>());